import { render, staticRenderFns } from "./MessageCheckbox.vue?vue&type=template&id=52c0508d&scoped=true"
import script from "./MessageCheckbox.vue?vue&type=script&lang=js"
export * from "./MessageCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MessageCheckbox.vue?vue&type=style&index=0&id=52c0508d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c0508d",
  null
  
)

export default component.exports